import { render, staticRenderFns } from "./ForgotpasswordView.vue?vue&type=template&id=8fed5f1c&scoped=true"
import script from "./ForgotpasswordView.vue?vue&type=script&lang=js"
export * from "./ForgotpasswordView.vue?vue&type=script&lang=js"
import style0 from "./ForgotpasswordView.vue?vue&type=style&index=0&id=8fed5f1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fed5f1c",
  null
  
)

export default component.exports